module LinksManager.SharedConfigTypes.Monadic

open System

/// Represents the abstract type of the configured value
[<RequireQualifiedAccess>]
type ConfigDataType =
    /// There is no simple way to explain this type, or it is something opaque or temporary
    | Unspecified
    | String
    | Int
    | PositiveInt
    | Bool
    | BoolOpt
    | StringOpt
    | Date
    | DateOpt
    /// Use this for where there is no other suitable option
    | Other
    | CommaSeparatedList
    | XML
    | Union of string list

module ConfigDataType =
    let toString =
        function
        | ConfigDataType.Unspecified -> "Unknown"
        | ConfigDataType.String -> "Text"
        | ConfigDataType.Int -> "Integer"
        | ConfigDataType.PositiveInt -> "Integer (> 0)"
        | ConfigDataType.Bool -> "Bool"
        | ConfigDataType.BoolOpt -> "Bool (optional)"
        | ConfigDataType.StringOpt -> "Text (optional)"
        | ConfigDataType.Date -> "Date"
        | ConfigDataType.DateOpt -> "Date (optional)"
        | ConfigDataType.Other -> "Other"
        | ConfigDataType.CommaSeparatedList -> "Comma-separated list"
        | ConfigDataType.XML -> "XML"
        | ConfigDataType.Union opts -> opts |> String.concat " | "

/// Metadata for a configured setting
type ConfigMeta =
    {
        Key: string
        DataType: ConfigDataType
        Section: string
        DefaultValue: string
        ConfiguredValue: string option
        Explanation: string
        Examples: string option
    }

/// Metadata structure for a config file
type ConfigMetadata =
    {
        AsOf: DateTime
        ConfigHash: string
        MetadataHash: string
        ConfigMeta: ConfigMeta list
    }